const LIMIT_CODES = new Set(['guest_daily_limit', 'daily_limit_reached', 'guest_pending_upload_limit',
  'upload_pending_limit', 'free_duration_limit', 'free_size_limit', 'premium_size_limit', 'file_too_large']);
const FAILURE_EVENTS = new Set(['upload_error', 'url_import_error', 'podcast_import_error',
  'podcast_resolve_error', 'transcription_start_error']);

export function productLimitEvent(eventName, params = {}) {
  if (eventName === 'upload_error' && params.error_code === 'upload_already_active') {
    return { eventName: 'upload_duplicate_prevented', params: { ...params, error_type: 'state' } };
  }
  // A generic 429/5xx is still a technical error. Only known product allowances
  // become limit outcomes, with the actual operation/source and recovery intact.
  const code = params.error_code;
  if (!LIMIT_CODES.has(code) || Number(params.status_code) >= 500) return { eventName, params };
  const isFailure = FAILURE_EVENTS.has(eventName);
  const isRecovery = /^upload_recovery_(shown|action)$/.test(eventName);
  if (!isFailure && !isRecovery) return { eventName, params };
  return {
    eventName: isFailure ? eventName.replace(/_error$/, '_limit_reached') : eventName,
    params: { ...params, error_type: 'plan_limit', limit_type: code },
  };
}
